import { ChainId, chainNames } from '@pancakeswap/chains'
import memoize from 'lodash/memoize'
import { Chain, bsc as bsc_, mainnet, polygon } from 'wagmi/chains'

export const CHAIN_QUERY_NAME = chainNames

const CHAIN_QUERY_NAME_TO_ID = Object.entries(CHAIN_QUERY_NAME).reduce((acc, [chainId, chainName]) => {
  return {
    [(chainName || '').toString().toLowerCase()]: chainId as unknown as ChainId,
    ...acc,
  }
}, {} as Record<string, ChainId>)

export const getChainId = memoize((chainName: string) => {
  if (!chainName) return undefined
  return CHAIN_QUERY_NAME_TO_ID[chainName.toLowerCase()] ? +CHAIN_QUERY_NAME_TO_ID[chainName.toLowerCase()] : undefined
})

const BSC = {
  ...bsc_,
  name: 'BNB Chain',
  rpcUrls: {
    ...bsc_.rpcUrls,
    public: {
      ...bsc_.rpcUrls.public,
      http: ['https://bsc-dataseed.binance.org/'],
    },
    default: {
      ...bsc_.rpcUrls.default,
      http: ['https://bsc-dataseed.binance.org/'],
    },
  },
} satisfies Chain

// add chain onus mainnet

export const onusMainnet = {
  id: 1975,
  name: 'ONUS Chain',
  network: 'onus-mainnet',
  nativeCurrency: { name: 'ONUS', symbol: 'ONUS', decimals: 18 },
  rpcUrls: {
    public: {
      ...bsc_.rpcUrls.public,
      http: ['https://rpc.onuschain.io/'],
    },
    default: {
      ...bsc_.rpcUrls.default,
      http: ['https://rpc.onuschain.io/'],
    },
  },
  blockExplorers: {
    default: {
      name: 'ONUS Chain',
      url: 'https://explorer.onuschain.io/',
    },
  },
  testnet: false,
} satisfies Chain

export const POLYGON = {
  ...polygon,
  name: 'Polygon',
} satisfies Chain

// cấu hình các mạng có thể connect smart contract
export const CHAINS = [onusMainnet, BSC, POLYGON, mainnet]
